import { useAuth } from 'Components/Auth'
import { useInfiniteQuery } from 'react-query'

import { makeEventsApiPath } from './constants'

export const useEventsQuery = (queryString = '', limit = 15) => {
  const { axios } = useAuth()
  const EVENTS_URL = makeEventsApiPath()

  return useInfiniteQuery({
    queryKey: [EVENTS_URL, queryString],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        _page: pageParam,
        _limit: limit,
      }
      const { data } = await axios.get(`${EVENTS_URL}?${queryString}`, { params })

      return data
    },
    select: (data) =>
      data.pages.reduce(
        (acc, page) => {
          const pageRelations = page.relations || {}
          const mergedRelations = Object.keys(pageRelations).reduce(
            (relationsAcc, key) => ({
              ...relationsAcc,
              [key]: { ...relationsAcc[key], ...pageRelations[key] },
            }),
            acc.relations,
          )

          return {
            data: acc.data.concat(page.data),
            relations: mergedRelations,
          }
        },
        { data: [], relations: {} },
      ),
    getNextPageParam: (lastPage) => {
      if (lastPage.page == null) return undefined
      const nextPage = lastPage.page + 1
      if (nextPage > lastPage.pages) return undefined
      return nextPage
    },
    initialPageParam: 1,
  })
}

export const useEventsRoadmapQuery = () =>
  useEventsQuery(`_sort=${encodeURIComponent('-is_started,time_begin')}&is_finished=false&is_archived=false`)

export const useEventsInProgressQuery = (limit) =>
  useEventsQuery(
    `_sort=${encodeURIComponent('-time_begin,-time_created')}&is_started=true&is_finished=false&is_archived=false`,
    limit,
  )

export const useEventsFinishedQuery = () =>
  useEventsQuery(`_sort=${encodeURIComponent('-time_begin,-time_created')}&is_finished=true&is_archived=false`)

export const useEventsArchivedQuery = () =>
  useEventsQuery(`_sort=${encodeURIComponent('-time_archived,-time_created')}&is_archived=true`)
